import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import { Flex } from '@magnetic/flex';
import styled from 'styled-components';
import moment from 'moment';
import { getQRCode } from '../navigate-on-phone';
import { clearPOISelection, getAllDesks, getAllRooms, getDestinationRichMapId, getOpenRoomDetailsWithQR, getSmartRooms, setDirectionsPanel, setOpenRoomDetailsWithQR, setRoomDetailsPopUp, setShowQRFrame, } from '../../../../../store/uislice';
import { store } from '../../../../../store/store';
import { getPOIS, getUIState } from '../../../../../store/uislice';
import { TelemetryWidget } from '../../../common/telemetry-widget';
import { getWidgetCount, hasValue } from '../../../navigator/util';
import { availabilityStatusBorderMap, availabilityStatusColorMap, } from '../../util';
import TimeLine from './time-line/Styled-Time-Line';
import { getContext, getLocation, selectRoomById, selectFloorById, getSelectedLocation, } from '../../../redux/spaces-slice';
import natsclient from '../../../../../store/natsclient';
import Close from '../../../../../assets/svgs/close-svg';
import GetDirectionsArrowSVG from '../../../../../assets/images/get-directions-arrow.svg';
import HoldRoomClockSVG from '../../../../../assets/images/hold-room-clock.svg';
import { vwToPixels, STATUSES } from '../../util';
import { startDirections } from '../map/directions';
import { resolveDeskBookable, resolveShowOccupancy, resolveShowPathFinding, resolveShowWayFinding, } from '../../util/show-path-finding';
import { isHiddenOnKiosk } from '../../util/show-on-kiosk';
import { resolveWhereAmIFloor } from '../../util/where-am-i';
const RoomDetailsPopupContainer = styled(Flex) `
  height: fit-content;
  width: 99%;
  z-index: 6;
  right: 0;
  width: fit-content;
  margin: auto;
  position: fixed;
  bottom: 0;
  /* Lifted a touch (was 4.2vw) so the bottom-center language picker and the
     bottom-right SPACES logo stay visible while the popup is open. */
  margin-bottom: 6vw;
  margin-right: 2vw;

  @media (orientation: portrait) {
    bottom: 40%;
    margin-bottom: 0;
  }
`;
const RoomDetailsPopupWidget = styled(Flex) `
  background: #1d2023;
  width: 22vw;
  padding: 1vw;
  border-radius: 0.6vw;
`;
const ActionButtonsRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 22.4vw;
  margin: 0.4vw 0vw 0.2vw 0vw;
`;
const ActionButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.42vw;
  width: 10.9vw;
  height: 3.45vw;
  padding: 0vw 0.42vw;
  box-sizing: border-box;
  border-radius: 0.42vw;
  border: 0.05vw solid
    ${(props) => {
    if (props.$disabled)
        return 'transparent';
    return props.$variant === 'directions' ? '#68adff' : '#57c637';
}};
  color: #ffffff;
  text-align: left;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  box-shadow: 0vw 0.2vw 0.2vw rgba(0, 0, 0, 0.4);
  background: ${(props) => {
    if (props.$variant === 'directions')
        return '#1d7ff3';
    return props.$disabled ? 'rgba(49, 54, 62, 0.5)' : '#41872d';
}};
`;
const ActionIcon = styled.img `
  flex: 0 0 auto;
  width: 2.1vw;
  height: 2.1vw;
`;
const ActionTextBlock = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.2vw;
  min-width: 0;
`;
const ActionTitle = styled.span `
  font-family: 'Sora', sans-serif;
  font-size: 0.95vw;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ActionSubtitle = styled.span `
  font-family: 'Sora', sans-serif;
  font-size: 0.58vw;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const RoomTitle = styled.div `
  margin: 1vw 0vw;
  font-size: 1.6vw;
`;
const QRContainer = styled.div `
  margin: 0.6vw 0vw;
  position: relative;
  width: 22vw;
`;
const QRImage = styled.img `
  width: 22vw;
  display: block;
`;
/* The frame graphic ships with the title/footer copy baked into the pixels.
   To make that copy localizable we cover those two regions with a matching
   solid-black strip (the image interior is pure #000) and render real,
   translatable text on top. The image + QR rendering below is otherwise
   untouched. */
const QRCopyOverlay = styled.div `
  position: absolute;
  left: 6%;
  right: 6%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  background: #000000;
  line-height: 1.1;
  pointer-events: none;
`;
const QRCopyTitle = styled(QRCopyOverlay) `
  top: 3.4%;
  height: 9.5%;
  font-size: 1.25vw;
  font-weight: 400;
`;
const QRCopyFooter = styled(QRCopyOverlay) `
  top: 82.2%;
  height: 6%;
  font-size: 0.98vw;
  font-weight: 400;
`;
const Text = styled(Flex) `
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1vw')};
  margin: ${(props) => props.margin};
  color: ${(props) => (props.color ? props.color : 'white')};
`;
const CalendarContainer = styled.div `
  height: fit-content;
  width: ${(props) => (props.$stacked ? '100%' : '48%')};
  margin-right: ${(props) => (props.$stacked ? '0' : '0.4vw')};
`;
const RoomOccupancyContainer = styled(Flex) `
  width: ${(props) => props.widgetCount === 0 || !props.showTimeLine ? '102%' : '94%'};
  height: fit-content;
  min-height: ${(props) => props.widgetCount === 0 || !props.showTimeLine ? 'auto' : '4.55vw'};
  background: #2a2f33;
  border-radius: 0.4vw;
  padding: 0.4vw;
  box-sizing: border-box;
  margin: 0.4vw 0vw;
`;
const RoomAnalyticsContainer = styled(Flex) `
  margin: 1vw 0vw;
`;
const RoomAnalyticsRow = styled(Flex) `
  margin-bottom: 0.6vw;
  height: fit-content;
  width: ${(props) => (props.$stacked ? '102%' : '104%')};
`;
const SmartRoomCard = styled.div `
  position: relative;
  width: 100%;
  margin-bottom: 0.2vw;
  line-height: 0;
`;
const SmartRoomImg = styled.img `
  display: block;
  width: 100%;
`;
const SmartRoomCopy = styled.div `
  position: absolute;
  left: 19.5%;
  top: 50%;
  transform: translateY(-50%);
  max-width: 74%;
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  line-height: 1.15;
`;
const SmartRoomTitle = styled.div `
  font-size: clamp(0.6rem, 0.68vw, 0.78rem);
  font-weight: 400;

  strong {
    font-weight: 800;
  }
`;
const SmartRoomSubtitle = styled.div `
  margin-top: clamp(0.16rem, 0.18vw, 0.22rem);
  color: #9e9ea2;
  font-size: clamp(0.48rem, 0.56vw, 0.64rem);
  font-weight: 400;
`;
const TelepresenceRow = styled.div `
  display: flex;
  align-items: center;
  gap: 0.42vw;
  margin: 0.2vw 0 0.55vw 0;
`;
const TelepresenceLogoWrap = styled.div `
  position: relative;
  width: 1.45vw;
  height: 1.45vw;
  flex: 0 0 auto;
`;
const TelepresenceLogo = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const TelepresenceBadge = styled.img `
  position: absolute;
  right: -0.18vw;
  bottom: -0.12vw;
  width: 0.78vw;
  height: 0.78vw;
`;
const TelepresenceText = styled.span `
  font-family: 'Sora', sans-serif;
  font-size: 0.78vw;
  font-weight: 600;
  color: #ffffff;
`;
const AvailabilityStatusContainer = styled(Flex) `
  height: fit-content;
  min-height: ${(props) => props.widgetCount === 0 || !props.showTimeLine ? 'auto' : '4.55vw'};
  width: ${(props) => props.widgetCount === 0 || !props.showTimeLine ? '102%' : '100%'};
  padding: 0.48vw 0.72vw;
  box-sizing: border-box;
  border-radius: ${(props) => (props.isDesk ? '0.6vw' : '0.6vw 0.6vw 0vw 0vw')};
  background: ${(props) => props.background};
  border: 2px solid ${(props) => props.borderColor};
`;
const AvailabilityLabel = styled.div `
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  font-size: 0.8vw;
  line-height: 1.15;
  /* Keep the label on a single line and clip with an ellipsis when a translation
     is too long for the status box (mirrors the action-button titles). */
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const AvailabilityValue = styled.div `
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  font-size: 1.68vw;
  font-weight: 400;
  line-height: 1;
  /* Clip the status word with an ellipsis when a translation overflows the box
     (same single-line treatment as the label above). */
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const QRView = ({ QRCode, isQRFrameImageLoaded }) => {
    const { t } = useTranslation();
    return (isQRFrameImageLoaded && (_jsxs(QRContainer, { children: [_jsx(QRImage, { src: require('../../../../../assets/images/get-directions-on-your-phone.png') }), _jsx(Flex, Object.assign({ style: { margin: '-18vw 0vw 0vw 4.6vw', position: 'fixed' } }, { children: _jsx(QRCodeSVG, { value: QRCode, size: vwToPixels(12), bgColor: "#000000", fgColor: "#ffffff", level: "L" }) })), _jsx(QRCopyTitle, { children: t('floor.room-details-popup.qr-directions-title') }), _jsx(QRCopyFooter, { children: t('floor.room-details-popup.qr-directions-footer') })] })));
};
export const closeRoomDetailsPopup = () => {
    var _a, _b;
    setTimeout(() => {
        window.rMap.exitNavigation();
        // (window as any).rMap.reset();
    }, 200);
    store.dispatch(setRoomDetailsPopUp({ payload: null }));
    store.dispatch(setDirectionsPanel({ payload: null }));
    store.dispatch(setShowQRFrame({ payload: true }));
    if (document.getElementById('get_directions_btn') &&
        ((_a = document
            .getElementById('get_directions_btn')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-showQR')) === 'true') {
        (_b = document.getElementById('get_directions_btn')) === null || _b === void 0 ? void 0 : _b.click();
    }
    store.dispatch(clearPOISelection());
};
const getPoiID = (POISNameMap, name) => {
    var _a;
    for (const POI in POISNameMap) {
        if (POISNameMap[POI].name === name || POISNameMap[POI].poiId === name) {
            return POISNameMap[POI].poiId;
        }
        else if (((_a = POISNameMap[POI]) === null || _a === void 0 ? void 0 : _a.name) && POISNameMap[POI].name.includes('~')
            ? POISNameMap[POI].name.slice(POISNameMap[POI].name.indexOf('~') + 1)
            : POISNameMap[POI].name === name) {
            return POISNameMap[POI].poiId;
        }
    }
};
const Calendar = ({ t, widgetCount, meetings, timeZoneId, status, showTimeLine, isPOI, isWebexRoom, showOccupancy = true, isDesk, deskId, bookingSubject, roomAnalytics, }) => {
    const formattedMeetingList = getFormattedMeetingList(meetings, timeZoneId);
    const timeLineDate = moment().tz(timeZoneId).clone();
    const timeLineStatus = String(status).toLowerCase();
    const showAvailabilityCard = !isPOI && isWebexRoom && showOccupancy;
    if (isDesk) {
        return (_jsx(CalendarContainer, Object.assign({ "$stacked": widgetCount === 0 || !showTimeLine }, { children: showOccupancy && (_jsx(AvailabilityStatus, { t: t, widgetCount: widgetCount, status: status, showTimeLine: showTimeLine, isDesk: isDesk })) })));
    }
    return (_jsxs(CalendarContainer, Object.assign({ "$stacked": widgetCount === 0 || !showTimeLine }, { children: [showAvailabilityCard && (_jsx(AvailabilityStatus, { t: t, widgetCount: widgetCount, status: status, showTimeLine: showTimeLine, isDesk: isDesk })), showTimeLine && (_jsx(TimeLine, { "$roundedTop": !showAvailabilityCard, style: {
                    marginTop: showAvailabilityCard ? '0.7vw' : 0,
                }, date: moment().tz(timeZoneId).clone(), timeZoneId: timeZoneId, meetings: formattedMeetingList, status: status.toLowerCase(), timeLineLimit: 8, widgetCount: widgetCount }))] })));
};
const RoomOccupancy = ({ t, widgetCount, showTimeLine, showPeopleCount, peopleCount, capacity, }) => {
    if (capacity === -1)
        capacity = 0;
    if (!showPeopleCount || (!peopleCount && !capacity)) {
        return _jsx(_Fragment, {});
    }
    let roomOccupancyLabel = t('floor.room-details-popup.room-occupancy');
    if (peopleCount === -1) {
        roomOccupancyLabel = t('floor.room-details-popup.room-capacity');
    }
    return (_jsxs(RoomOccupancyContainer, Object.assign({ direction: widgetCount === 0 || !showTimeLine ? 'horizontal' : 'vertical', widgetCount: widgetCount, showTimeLine: showTimeLine, justify: "space-between" }, { children: [_jsx(Text, Object.assign({ fontSize: "0.8vw", style: { paddingTop: (widgetCount === 0 || !showTimeLine) && '1vw' } }, { children: roomOccupancyLabel })), _jsxs(Flex, Object.assign({ justify: "space-between", style: { width: widgetCount === 0 || !showTimeLine ? '30%' : '64%' } }, { children: [_jsx(Text, Object.assign({ fontSize: "2.2vw" }, { children: peopleCount })), capacity !== 0 && (_jsx(Text, Object.assign({ margin: "1.2vw 0vw 0vw 0vw", style: { color: '#9E9EA2' } }, { children: t('floor.room-details-popup.of') }))), capacity !== 0 && (_jsx(Text, Object.assign({ fontSize: "2.2vw", style: { color: '#00BCEB' } }, { children: capacity })))] }))] })));
};
const AvailabilityStatus = ({ t, widgetCount, status, showTimeLine, isDesk, }) => {
    const label = isDesk
        ? t('floor.room-details-popup.this-desk-is')
        : t('floor.room-details-popup.this-meeting-room-is');
    const value = t(`floor.room-details-popup.${status}`);
    return (_jsxs(AvailabilityStatusContainer, Object.assign({ direction: "vertical", justify: "space-between", background: availabilityStatusColorMap[status], borderColor: availabilityStatusBorderMap[status], widgetCount: widgetCount, showTimeLine: showTimeLine, isDesk: isDesk }, { children: [_jsx(AvailabilityLabel, Object.assign({ title: label }, { children: label })), _jsx(AvailabilityValue, Object.assign({ title: value }, { children: value }))] })));
};
const RoomAnalytics = ({ iaq, co2, temperature, humidity, ambientNoise, showTimeLine, config, }) => {
    const widgets = [];
    if (hasValue(iaq) && (config === null || config === void 0 ? void 0 : config.showAirQuality)) {
        widgets.push(_jsx(TelemetryWidget, { size: "xs", type: 'IAQ', status: iaq }));
    }
    if (hasValue(co2) && (config === null || config === void 0 ? void 0 : config.showCO2)) {
        widgets.push(_jsx(TelemetryWidget, { size: "xs", type: 'CO2', status: co2 }));
    }
    if (hasValue(temperature) && (config === null || config === void 0 ? void 0 : config.showTemperature)) {
        widgets.push(_jsx(TelemetryWidget, { size: "xs", type: 'TEMPERATURE', status: temperature }));
    }
    if (hasValue(humidity) && (config === null || config === void 0 ? void 0 : config.showHumidity)) {
        widgets.push(_jsx(TelemetryWidget, { size: "xs", type: 'HUMIDITY', status: humidity }));
    }
    if (hasValue(ambientNoise)) {
        widgets.push(_jsx(TelemetryWidget, { size: "xs", type: 'AMBIENT_NOISE', status: 'noise_' + ambientNoise }));
    }
    return showTimeLine ? (_jsxs(RoomAnalyticsContainer, Object.assign({ direction: "vertical" }, { children: [_jsxs(RoomAnalyticsRow, Object.assign({ justify: "space-between" }, { children: [widgets.length > 0 && widgets[0], widgets.length > 1 && widgets[1]] })), _jsxs(RoomAnalyticsRow, Object.assign({ justify: "space-between" }, { children: [widgets.length > 2 && widgets[2], widgets.length > 3 && widgets[3]] })), _jsx(RoomAnalyticsRow, { children: widgets.length > 4 && widgets[4] })] }))) : (_jsxs(RoomAnalyticsContainer, Object.assign({ direction: "vertical" }, { children: [_jsxs(RoomAnalyticsRow, Object.assign({ justify: "space-between", "$stacked": true }, { children: [widgets.length > 0 && widgets[0], widgets.length > 1 && widgets[1], widgets.length > 2 && widgets[2], widgets.length > 3 && widgets[3]] })), _jsx(RoomAnalyticsRow, { justify: "space-between", "$stacked": true }), _jsx(RoomAnalyticsRow, Object.assign({ "$stacked": true }, { children: widgets.length > 4 && widgets[4] }))] })));
};
const getFormattedMeetingList = (meetings, timeZoneId) => {
    return meetings.map((meet) => {
        const { startTime, endTime } = meet;
        return {
            start: moment.unix(startTime).tz(timeZoneId),
            end: moment.unix(endTime).tz(timeZoneId),
        };
    });
};
const renderSmartRoomTitle = (title) => {
    const highlight = 'Smart Room';
    const highlightIndex = title.indexOf(highlight);
    if (highlightIndex === -1) {
        return title;
    }
    return (_jsxs(_Fragment, { children: [title.slice(0, highlightIndex), _jsx("strong", { children: highlight }), title.slice(highlightIndex + highlight.length)] }));
};
const SmartRoom = () => {
    const { t } = useTranslation();
    const title = t('room-details-popup.smart-room-1');
    return (_jsxs(SmartRoomCard, { children: [_jsx(SmartRoomImg, { src: require('../../../../../assets/images/smart-room-localized.png'), alt: "", "aria-hidden": "true" }), _jsxs(SmartRoomCopy, { children: [_jsx(SmartRoomTitle, { children: renderSmartRoomTitle(title) }), _jsx(SmartRoomSubtitle, { children: t('room-details-popup.smart-room-2') })] })] }));
};
const RoomDetailsPopup = memo(({ floorId }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const { t } = useTranslation();
    const [isQRFrameImageLoaded, setQRFrameImageLoaded] = useState(false);
    // Preload the QR frame image once on mount instead of creating/decoding a new
    // Image on every render (the previous version ran during the render body and
    // added avoidable work to each popup re-render).
    useEffect(() => {
        const QRFrameImage = new Image();
        QRFrameImage.onload = () => setQRFrameImageLoaded(true);
        QRFrameImage.src = require('../../../../../assets/images/get-directions-on-your-phone.png');
    }, []);
    const locationData = useSelector(getLocation);
    let floorLocationId = useSelector(getSelectedLocation);
    if (!floorLocationId)
        floorLocationId = locationData === null || locationData === void 0 ? void 0 : locationData.children[0].id;
    const contextInfo = useSelector(getContext);
    const config = (_a = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _a === void 0 ? void 0 : _a.floor;
    const UIState = useSelector(getUIState);
    const destinationRichMapId = useSelector(getDestinationRichMapId);
    const richMapId = UIState.popupRichMapID;
    const roomAnalytics = useSelector((state) => selectRoomById(state, richMapId));
    const floorAnalytics = useSelector((state) => selectFloorById(state, floorLocationId));
    const isPOI = false; // isWebex is a sufficient check, TODO : verify
    let availability = (_c = STATUSES[(_b = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.availability) === null || _b === void 0 ? void 0 : _b.toUpperCase()]) !== null && _c !== void 0 ? _c : 'Unknown';
    const roomInfo = (_d = floorAnalytics === null || floorAnalytics === void 0 ? void 0 : floorAnalytics.availabilityInfo) === null || _d === void 0 ? void 0 : _d.roomInfo;
    const isWebexRoom = roomAnalytics &&
        ((roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.available.includes(richMapId)) ||
            (roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.booked.includes(richMapId)) ||
            (roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.hold.includes(richMapId)) ||
            (roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.occupied.includes(richMapId)) ||
            (roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.noData.includes(richMapId)));
    const telepresence = (_e = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.telepresence) !== null && _e !== void 0 ? _e : false;
    const checkMarkImage = telepresence
        ? require('../../../../../assets/images/checkmark.png')
        : require('../../../../../assets/images/closemark.png');
    const iaq = (_f = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.airQuality) !== null && _f !== void 0 ? _f : null;
    const temperature = (_g = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.ambientTemp) !== null && _g !== void 0 ? _g : null;
    const co2 = (_h = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.co2) !== null && _h !== void 0 ? _h : null;
    const humidity = (_j = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.relativeHumidity) !== null && _j !== void 0 ? _j : null;
    const ambientNoise = (_k = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.ambientNoise) !== null && _k !== void 0 ? _k : null;
    const peopleCount = (_l = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.peopleCount) !== null && _l !== void 0 ? _l : 0;
    const capacity = (_m = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.capacity) !== null && _m !== void 0 ? _m : 0;
    // Honored from the LH room object below. Defaults to today's behavior
    // (holdable) unless the room explicitly sends `hold: false`.
    let holdable = true;
    let showCalendar = false, showPeopleCount = true;
    const roomId = (_o = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.id) !== null && _o !== void 0 ? _o : '';
    const POISData = useSelector(getPOIS);
    const POISNameMap = POISData.POISNameMap;
    const allRoomsList = useSelector(getAllRooms);
    const allDesksList = useSelector(getAllDesks);
    const [QRCode, setQRCode] = useState('');
    const [, setQRCodeSize] = useState(vwToPixels(12));
    const [showQR, setShowQR] = useState(false);
    const openWithQR = useSelector(getOpenRoomDetailsWithQR);
    const tenantId = locationData === null || locationData === void 0 ? void 0 : locationData.tenant;
    const locationId = locationData === null || locationData === void 0 ? void 0 : locationData.id;
    const smartRooms = useSelector(getSmartRooms);
    const isSmartRoom = smartRooms.includes(richMapId);
    const meetings = (_p = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.meetings) !== null && _p !== void 0 ? _p : [];
    let timeZoneId = (_q = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.timeZoneId) !== null && _q !== void 0 ? _q : 'Etc/UTC';
    if (timeZoneId === '')
        timeZoneId = 'Etc/UTC';
    const locationDataRooms = (locationData === null || locationData === void 0 ? void 0 : locationData.children.length) === 1
        ? locationData === null || locationData === void 0 ? void 0 : locationData.children[0].rooms
        : (_r = locationData === null || locationData === void 0 ? void 0 : locationData.children.find((child) => child.id === floorLocationId)) === null || _r === void 0 ? void 0 : _r.rooms;
    // Room-level `showOnKioskAndWebApp === false` suppresses this popup entirely,
    // no matter how it was opened (map click, search, etc). Only an explicit
    // `false` acts; absent/null/true keep today's behavior.
    let roomHiddenOnKiosk = false;
    if (locationDataRooms) {
        for (const room of locationDataRooms) {
            const roomCopy = room;
            if (roomCopy.richMapId === richMapId) {
                showCalendar = roomCopy.showCalendar;
                showPeopleCount = roomCopy.showPeopleCount;
                roomHiddenOnKiosk = isHiddenOnKiosk(roomCopy);
                // Pick the per-room `hold` capability straight from LH. Only an explicit
                // boolean acts; absent/null/non-boolean keeps the existing behavior.
                if (typeof roomCopy.hold === 'boolean') {
                    holdable = roomCopy.hold;
                }
                break;
            }
        }
    }
    const showTimeLine = !isPOI && showCalendar;
    const richMapIdWithoutFloorNumber = richMapId === null || richMapId === void 0 ? void 0 : richMapId.split('~')[1];
    const widgetCount = getWidgetCount(iaq, temperature, co2, humidity, ambientNoise);
    const isWayFindingEnabled = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWayFindingEnabled;
    const isPathFindingEnabled = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isPathFindingEnabled;
    // Tenant/context base for path drawing (the wayfinding||pathfinding matrix).
    const tenantPathDrawingEnabled = Boolean(isWayFindingEnabled || isPathFindingEnabled);
    const whereAmIFloor = resolveWhereAmIFloor(locationData, contextInfo);
    const deviceLocationId = whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.id;
    const deviceFloorNumber = Number(whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.floorNumber);
    // Resolve the feature's floor number from the SAME source the search list
    // uses (feature `properties.lvl`, surfaced on allRooms/allDesks/POIs), keyed
    // by the rich map id. This avoids `Number(richMapId.split('~')[0])`, which is
    // NaN for features whose id has no numeric floor prefix (e.g. bare-UUID POI
    // ids) — the cause of the "NaN floor" in the directions stepper (and of the
    // multifloor bar being wrongly triggered on the current floor).
    const resolveFeatureFloorNumber = (id) => {
        var _a;
        if (!id)
            return NaN;
        const matchInList = (list) => list === null || list === void 0 ? void 0 : list.find((entry) => (entry === null || entry === void 0 ? void 0 : entry.key) === id);
        const roomMatch = matchInList(allRoomsList);
        if (roomMatch && Number.isFinite(Number(roomMatch.floorNumber))) {
            return Number(roomMatch.floorNumber);
        }
        const deskMatch = matchInList(allDesksList);
        if (deskMatch && Number.isFinite(Number(deskMatch.floorNumber))) {
            return Number(deskMatch.floorNumber);
        }
        for (const type of Object.keys((POISData === null || POISData === void 0 ? void 0 : POISData.POIS) || {})) {
            for (const poi of POISData.POIS[type] || []) {
                if ((poi === null || poi === void 0 ? void 0 : poi.id) === id) {
                    const lvl = Number((_a = poi === null || poi === void 0 ? void 0 : poi.properties) === null || _a === void 0 ? void 0 : _a.lvl);
                    if (Number.isFinite(lvl))
                        return lvl;
                }
            }
        }
        // Legacy fallback: numeric floor prefix on the rich map id.
        return Number(id.split('~')[0]);
    };
    const roomFloorNumber = resolveFeatureFloorNumber(richMapId);
    // Honor the hierarchical LH `showPathFinding` flag (building -> floor) on top
    // of the tenant base, scoped to this room/desk's floor. Only explicit
    // booleans disable; absent/null inherit, so behavior is unchanged when the
    // flag isn't present. This governs on-map path drawing + the stepper only.
    const drawingOnMap = Boolean(whereAmIFloor) &&
        resolveShowPathFinding({
            location: locationData,
            floorNumber: roomFloorNumber,
            tenantPathDrawingEnabled,
        });
    // Wayfinding QR display is governed independently by the hierarchical LH
    // `showWayFinding` flag (tenant base = `isWayFindingEnabled` only ->
    // building -> floor), scoped to this room/desk's floor. When false, no QR is
    // shown in this popup for that floor.
    const wayFindingForFloor = resolveShowWayFinding({
        location: locationData,
        floorNumber: roomFloorNumber,
        tenantWayFindingEnabled: Boolean(isWayFindingEnabled),
    });
    // The Get Directions button is a composite trigger: it appears when EITHER
    // path drawing OR QR display is enabled for this floor. Clicking it draws the
    // path/stepper only when `drawingOnMap` is on, and shows the QR only when
    // `wayFindingForFloor` is on — so a floor with pathfinding off but wayfinding
    // on still surfaces the button and the QR (just no on-map route/stepper).
    const showDirectionsButton = drawingOnMap || wayFindingForFloor;
    useEffect(() => {
        if (!wayFindingForFloor)
            return;
        const handleResize = () => {
            setQRCodeSize(vwToPixels(12));
        };
        window.addEventListener('resize', handleResize);
        getQRCode({
            tenantId: tenantId,
            locationId: locationId,
            poiId: getPoiID(POISNameMap, richMapIdWithoutFloorNumber),
            setter: setQRCode,
        });
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (!wayFindingForFloor)
            return;
        getQRCode({
            tenantId: tenantId,
            locationId: locationId,
            poiId: getPoiID(POISNameMap, richMapIdWithoutFloorNumber),
            setter: setQRCode,
        });
        setShowQR(false);
    }, [richMapIdWithoutFloorNumber]);
    // When the popup was opened as a "Get directions" action without a where-am-I
    // source, open it directly in QR (navigate-on-phone) mode instead of drawing
    // a path. Consume the one-shot flag so it doesn't affect later normal opens.
    useEffect(() => {
        if (!openWithQR)
            return;
        if (wayFindingForFloor && richMapId) {
            setShowQR(true);
        }
        store.dispatch(setOpenRoomDetailsWithQR({ payload: false }));
    }, [openWithQR, wayFindingForFloor, richMapId]);
    const getDirectionsClickHandler = () => {
        var _a, _b;
        if (!showQR) {
            // Activating: draw the on-map path + stepper only when path drawing is
            // enabled for this floor. When only wayfinding is enabled we skip
            // startDirections entirely (no path, no stepper, no floor-widget hiding)
            // and just flip into the QR view below.
            if (richMapId && drawingOnMap) {
                startDirections({
                    currentFloorLocationId: floorLocationId,
                    deviceFloorNumber,
                    deviceLocationId,
                    drawingOnMap,
                    richMapId,
                    roomFloorNumber,
                    // Same name this popup shows as its title, so the stepper reuses it
                    // instead of parsing the rich map id.
                    roomName: ((_a = POISNameMap[richMapIdWithoutFloorNumber]) === null || _a === void 0 ? void 0 : _a.name) ||
                        ((_b = POISNameMap[richMapIdWithoutFloorNumber]) === null || _b === void 0 ? void 0 : _b.sType) ||
                        richMapIdWithoutFloorNumber,
                    tenantId,
                });
            }
        }
        else {
            // Going back: only tear down navigation if we actually started drawing a
            // path. For wayfinding-only there is nothing on the map to exit/reset.
            if (drawingOnMap) {
                store.dispatch(setShowQRFrame({ payload: true }));
                store.dispatch(setDirectionsPanel({ payload: null }));
                setTimeout(() => {
                    window.rMap.exitNavigation();
                    window.rMap.reset();
                }, 200);
            }
        }
        setShowQR(!showQR);
    };
    const holdClickHandler = () => {
        const subject = `hold.${locationId}.${floorLocationId}.${roomId}`;
        const message = {
            roomId: roomId,
            roomName: richMapIdWithoutFloorNumber,
            tenantId: tenantId,
            startTime: Math.ceil(Date.now() / 1000),
        };
        natsclient.publishToStream(subject, message);
    };
    const allDesks = useSelector(getAllDesks);
    const isDesk = allDesks.some((desk) => desk.key === richMapId);
    const deskId = roomAnalytics === null || roomAnalytics === void 0 ? void 0 : roomAnalytics.id;
    // Honor the hierarchical LH `deskBookable` flag (building -> floor) for this
    // desk's floor. When a desk sits on a floor where desks aren't bookable, its
    // details popup must not open. Rooms are unaffected. Absent/null/true keep
    // today's behavior.
    const deskBookableForFloor = resolveDeskBookable({
        location: locationData,
        floorNumber: roomFloorNumber,
    });
    const deskPopupBlocked = isDesk && !deskBookableForFloor;
    // Honor LH building/floor `showOccupancy` and room-level `hidden` for this
    // space. When occupancy is off, hide only the availability card,
    // disable Hold and remove the map highlight. Calendar and other widgets stay.
    const showOccupancyForEntity = resolveShowOccupancy({
        location: locationData,
        floorNumber: roomFloorNumber,
        richMapId,
    });
    // Keep the collaboration badge and hold prompt gated by occupancy.
    const effectiveIsWebexRoom = Boolean(isWebexRoom) && showOccupancyForEntity;
    const canHoldRoom = showOccupancyForEntity && holdable && availability === STATUSES.AVAILABLE;
    const bookingSubject = `bookings.${locationId}.${floorLocationId}.${deskId}`;
    return (_jsx(_Fragment, { children: richMapId &&
            !roomHiddenOnKiosk &&
            !deskPopupBlocked &&
            (!destinationRichMapId || showQR) && (_jsx(RoomDetailsPopupContainer, Object.assign({ justify: "end" }, { children: _jsxs(RoomDetailsPopupWidget, Object.assign({ direction: "vertical" }, { children: [_jsxs(Flex, Object.assign({ justify: "space-between" }, { children: [_jsx(RoomTitle, Object.assign({ title: ((_s = POISNameMap[richMapIdWithoutFloorNumber]) === null || _s === void 0 ? void 0 : _s.name)
                                    ? (_t = POISNameMap[richMapIdWithoutFloorNumber]) === null || _t === void 0 ? void 0 : _t.name
                                    : (_u = POISNameMap[richMapIdWithoutFloorNumber]) === null || _u === void 0 ? void 0 : _u.sType }, { children: ((_v = POISNameMap[richMapIdWithoutFloorNumber]) === null || _v === void 0 ? void 0 : _v.name)
                                    ? (_w = POISNameMap[richMapIdWithoutFloorNumber]) === null || _w === void 0 ? void 0 : _w.name
                                    : (_x = POISNameMap[richMapIdWithoutFloorNumber]) === null || _x === void 0 ? void 0 : _x.sType })), _jsx("div", Object.assign({ className: "room_popup_close_button" }, { children: _jsx(Close, { onClose: closeRoomDetailsPopup }) }))] })), showQR && wayFindingForFloor ? (_jsx(QRView, { QRCode: QRCode, isQRFrameImageLoaded: isQRFrameImageLoaded })) : (_jsxs(_Fragment, { children: [!isPOI && !isDesk && effectiveIsWebexRoom && (_jsxs(TelepresenceRow, { children: [_jsxs(TelepresenceLogoWrap, { children: [_jsx(TelepresenceLogo, { src: require('../../../../../assets/images/webex-collaboration.png'), alt: "", "aria-hidden": "true" }), _jsx(TelepresenceBadge, { src: checkMarkImage, alt: "", "aria-hidden": "true" })] }), _jsx(TelepresenceText, { children: t('floor.room-details-popup.collab-device') })] })), _jsx(Flex, { children: isSmartRoom && _jsx(SmartRoom, {}) }), _jsxs(Flex, Object.assign({ direction: widgetCount === 0 || !showTimeLine
                                    ? 'vertical'
                                    : 'horizontal' }, { children: [_jsx(Calendar, { t: t, showTimeLine: showTimeLine, widgetCount: widgetCount, meetings: meetings, timeZoneId: timeZoneId, status: availability, isPOI: isPOI, isWebexRoom: Boolean(isWebexRoom), showOccupancy: showOccupancyForEntity, isDesk: isDesk, deskId: deskId, bookingSubject: bookingSubject, roomAnalytics: roomAnalytics }), widgetCount !== 0 && showTimeLine && (_jsxs(Flex, Object.assign({ direction: "vertical", style: { width: '48%', marginLeft: '0.4vw' } }, { children: [_jsx(RoomOccupancy, { t: t, widgetCount: widgetCount, showTimeLine: showTimeLine, showPeopleCount: showPeopleCount, peopleCount: peopleCount, capacity: capacity }), _jsx(RoomAnalytics, { iaq: iaq, humidity: humidity, temperature: temperature, ambientNoise: ambientNoise, co2: co2, showTimeLine: showTimeLine, config: config })] }))), (widgetCount === 0 || !showTimeLine) && (_jsx(RoomOccupancy, { t: t, widgetCount: widgetCount, showTimeLine: showTimeLine, showPeopleCount: showPeopleCount, peopleCount: peopleCount, capacity: capacity })), widgetCount !== 0 && !showTimeLine && (_jsx(RoomAnalytics, { iaq: iaq, humidity: humidity, temperature: temperature, ambientNoise: ambientNoise, co2: co2, showTimeLine: showTimeLine, config: config }))] }))] })), _jsxs(ActionButtonsRow, { children: [showDirectionsButton ? (_jsxs(ActionButton, Object.assign({ type: "button", onClick: getDirectionsClickHandler, id: "get_directions_btn", "data-showQR": showQR, "$variant": "directions" }, { children: [_jsx(ActionIcon, { src: GetDirectionsArrowSVG, alt: "" }), _jsxs(ActionTextBlock, { children: [_jsx(ActionTitle, Object.assign({ title: showQR
                                                    ? t('floor.room-details-popup.go-back')
                                                    : t('floor.room-details-popup.get-directions') }, { children: showQR
                                                    ? t('floor.room-details-popup.go-back')
                                                    : t('floor.room-details-popup.get-directions') })), !showQR && (_jsx(ActionSubtitle, Object.assign({ title: t('floor.room-details-popup.view-route') }, { children: t('floor.room-details-popup.view-route') })))] })] }))) : (effectiveIsWebexRoom && holdable && (_jsxs(Flex, Object.assign({ direction: "vertical", style: { marginTop: '0.6vw' }, id: "room_popup_bottom_prompt" }, { children: [_jsx(Text, Object.assign({ fontSize: "0.9vw" }, { children: t('floor.room-details-popup.label-1') })), _jsx(Text, Object.assign({ color: "#9E9EA2", fontSize: "0.6vw" }, { children: availability === STATUSES.AVAILABLE
                                            ? t('floor.room-details-popup.label-2')
                                            : t('floor.room-details-popup.label-2-not-available') })), _jsx(Text, Object.assign({ color: "#9E9EA2", fontSize: "0.6vw" }, { children: availability === STATUSES.AVAILABLE
                                            ? t('floor.room-details-popup.label-3')
                                            : t('floor.room-details-popup.label-3-not-available') }))] })))), !isPOI && isWebexRoom && holdable && (_jsxs(ActionButton, Object.assign({ type: "button", id: "room_popup_hold_button", "$variant": "hold", "$disabled": !canHoldRoom, disabled: !canHoldRoom, onClick: canHoldRoom ? holdClickHandler : undefined }, { children: [_jsx(ActionIcon, { src: HoldRoomClockSVG, alt: "" }), _jsxs(ActionTextBlock, { children: [_jsx(ActionTitle, Object.assign({ title: t('floor.room-details-popup.hold-room') }, { children: t('floor.room-details-popup.hold-room') })), _jsx(ActionSubtitle, Object.assign({ title: t('floor.room-details-popup.hold-subtitle') }, { children: t('floor.room-details-popup.hold-subtitle') }))] })] })))] })] })) }))) }));
});
export default RoomDetailsPopup;
